import React, { memo } from 'react'
import DriverLocationsTrimbleMap, {
  TDriverLocationsTrimbleMapProps,
} from 'transfix-maps/components/DriverLocationsTrimbleMap'
import { POSITION_TYPE } from 'transfix-maps/types'

const getSelectedPositionType: TDriverLocationsTrimbleMapProps['getSelectedPositionType'] = (
  position,
  index
) => {
  const { type = POSITION_TYPE.PING } = position || {}
  if ([POSITION_TYPE.PING, POSITION_TYPE.LAST_PING].includes(type) && index === 0) {
    return POSITION_TYPE.LAST_PING
  }

  return type
}

type TOmittedProp = 'isNewWave' | 'mapStyle' | 'fitBoundsOptions' | 'navigationPosition'

export type TShipmentMapComponentProps = Omit<TDriverLocationsTrimbleMapProps, TOmittedProp> & {}

const ShipmentMapComponent = memo<TShipmentMapComponentProps>(
  ({ hideNearbyAttractions = false, positions, stops }) => {
    return (
      <DriverLocationsTrimbleMap
        positions={positions}
        stops={stops}
        maxZoom={5}
        navigationPosition='top-right'
        mapStyle='datalight'
        isNewWave={false}
        getSelectedPositionType={getSelectedPositionType}
        hideNearbyAttractions={hideNearbyAttractions}
      />
    )
  }
)

export default ShipmentMapComponent
